import detectMobile from "./detect-mobile.js";

/**
 * Параметры слайдера
 */
const settingSL = {
	type: "slider",
	perView: 3,
	gap: 40,
	rewind: false,
	breakpoints: {
		800: {
			perView: 1,
		},
		1000: {
			perView: 2,
		},
	},
};

/**
 * Добавление в объект слайдера нужных значений при инициализации
 *
 * @param Glide
 * @param Components
 * @returns {{mount(): void}}
 */
const mountMutateSL = function (Glide, Components) {
	return {
		mount() {
			Glide.sliderLength = Components.Sizes.length; // кол-во слайдов
			Glide.sliderMax = Components.Sizes.length - 2; // максимальный слайд
			Glide.sliderProgress = Components.Html.root.querySelector("[data-slider-laps='progress']"); // селектор прогресса
			Glide.prevBtn = Components.Html.root.querySelector("[data-glide-dir='<']"); // селектор кнопки назад
			Glide.nextBtn = Components.Html.root.querySelector("[data-glide-dir='>']"); // селектор кнопки вперед
		},
	};
};

/**
 * События после запуска и после переключения слайдов
 *
 * @param sliderLaps объект слайдера, который нужно отслеживать
 */
const eventsSliderRunSL = function (sliderLaps) {
	const isMobile = detectMobile();
	const sliderNow = sliderLaps.index + 1; // текущий слайд
	const { sliderMax, sliderLength } = sliderLaps;
	const sliderCount = isMobile ? sliderLength : sliderMax;
	const widthProgress = (sliderNow / sliderCount) * 100; // процент прогресса
	const { sliderProgress, prevBtn, nextBtn } = sliderLaps;

	prevBtn.disabled = nextBtn.disabled = false; // отключаем disabled
	sliderProgress.style.width = `${widthProgress <= 100 ? widthProgress : 100}%`; // ставим процент прогресса

	// отключаем кнопки если находимся в начале или в конце слайдера
	if (sliderNow === 1) return prevBtn.disabled = true;
	if (sliderNow === sliderCount) return nextBtn.disabled = true;
};

export { settingSL, mountMutateSL, eventsSliderRunSL };
